<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">{{ $t("lang.msg.warehouse") }}</span>
      <div class="flex space-x-2 w-full md:max-w-lg">
        <ButtonAction @action="toggleActive" color="gray" large>
          {{ showActive ? $t('lang.msg.viewDisactives') : $t('lang.msg.viewActives') }}
        </ButtonAction>
        <ButtonAction @action="openCreateModal" color="gray" large>
          {{ $t('lang.msg.add') }}
        </ButtonAction>
      </div>
    </div>
    <datatable
      :data="data"
      :headers="headers"
      @on-row-click="openItemView"
    />
    <TheModal
      :open="isModalOpen"
      @close="isModalOpen = false"
      :title="newItem.idWarehouse == undefined ? $t('lang.msg.createRecord') : $t('lang.msg.updateRecord')"
    >
      <template #body>
        <form class="pt-3 space-y-4">
          <InputWrapper :label="$t('lang.fields.name')" content="input" block>
            <InputText v-model="newItem.warehouseName" :name="$t('lang.fields.name')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.address')" content="input" block>
            <textarea
              v-model="newItem.warehouseAdress"
              :placeholder="$t('lang.fields.address')"
              class="form-textarea w-full pr-6"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
            <InputText v-model="newItem.warehousePhone" :name="$t('lang.fields.phone')" />
          </InputWrapper>
          <AdminToggleButton v-model="newItem.active" />
        </form>
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="addOrEditItem(`api/Warehouses/Add`, `api/Warehouses/Update`, true)"
          >{{ newItem.idWarehouse == undefined ? $t('lang.msg.add') : $t('lang.msg.update') }}</button>
        </span>
      </template>
    </TheModal>
  </div>
</template>

<script>
import AdminMixin from "@/components/mixins/AdminMixin";
import TheModal from "@/components/shared/TheModal";
import DataTable from "@/components/shared/DataTable";

export default {
  name: "Warehouses",
  mixins: [AdminMixin],
  components: {
    datatable: DataTable,
    TheModal
  },
  data() {
    return {
      data: [],
      headers: {
        warehouseName: this.$t("lang.fields.name"),
        warehouseAdress: this.$t("lang.fields.address"),
        warehousePhone: this.$t("lang.fields.phone"),
        clientName: this.$t("lang.msg.client"),
        active: {
          name: this.$t("lang.msg.active"),
          type: Boolean
        }
      }
    };
  },
  created() {
    this.fetchData(`api/Warehouses/GetWarehouse`);
  },
  methods: {
    openItemView(item) {
      this.$router.push({
        name: "adminWarehouseDetail",
        params: {
          idWarehouse: item.idWarehouse
        }
      });
    }
  }
};
</script>
